/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalculationQueueItemDto } from '../../models/calculation-queue-item-dto';

export interface GetQueue$Params {
}

export function getQueue(http: HttpClient, rootUrl: string, params?: GetQueue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalculationQueueItemDto>>> {
  const rb = new RequestBuilder(rootUrl, getQueue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CalculationQueueItemDto>>;
    })
  );
}

getQueue.PATH = '/v1/queue/get';
